import {
  ADD_TEXT_COLOR_REQUEST,
  ADD_TEXT_COLOR_SUCCESS,
  FETCH_RCE_SETTINGS_SUCCESS,
  type addTextColorRequest,
  type addTextColorSuccess,
  type fetchRceSettingsFailure,
  type fetchRceSettingsSuccess,
} from '../actions/rce-settings';

type RceSettingsState = {
  colorSettings: {
    customColors: string[];
  };
  error: boolean | null;
};

type AnyAction =
  | ReturnType<typeof addTextColorRequest>
  | ReturnType<typeof addTextColorSuccess>
  | ReturnType<typeof fetchRceSettingsSuccess>
  | ReturnType<typeof fetchRceSettingsFailure>;

const initialState: RceSettingsState = { colorSettings: { customColors: [] }, error: null };

export default function rceSettingsReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case ADD_TEXT_COLOR_REQUEST:
      return {
        ...state,
        colorSettings: {
          customColors: [...state.colorSettings.customColors, action.payload.color],
        },
      };

    case ADD_TEXT_COLOR_SUCCESS:
    case FETCH_RCE_SETTINGS_SUCCESS:
      return action.payload.rceSettings;

    default:
      return state;
  }
}
